import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import * as _ from 'lodash';
import numeral from 'numeral';

import { deepEqual } from '../utils';

import Stat, { StatsWrapper } from '../Shared/UI/Stat';
import { Progress, ProgressWrapper } from '../Shared/UI/Progress';
import Box from '../Shared/UI/Box';

import Backend from '../Layouts/Backend';
import PageHeader from '../Shared/Helpers/PageHeader';

class DashboardPage extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  render() {
    const lastHours = moment().subtract(24, 'hours');

    const vehiclesCount = {
      total: _.size(this.props.vehicles),
      positioning: _.countBy(this.props.vehicles, v => lastHours.valueOf() < _.get(v, 'position.time', 0)).true || 0,
      stopped: _.countBy(this.props.vehicles, v => _.get(v, 'position.ignition', false)).true || 0,
    };

    const modelsCount = _(this.props.vehicles)
      .countBy(v => `${v.brand || 'S/MARCA'}: ${v.model || 'S/MODELO'}`)
      .toPairs()
      .orderBy(v => v[1], ['desc'])
      .take(6)
      .map(v => [v[0], _.round(((v[1] / vehiclesCount.total) * 100))])
      .value();

    const positioningPercentage =
      _.round((vehiclesCount.positioning / vehiclesCount.total) * 100, 2);
    const stoppedPercentage =
      _.round((vehiclesCount.stopped / vehiclesCount.total) * 100, 2);

    const revenueSummary = _(this.props.vehicles)
      .map(v => _.get(v, `stats.freightAmount.${moment().format('YYYYMM')}`, 0))
      .thru(freightAmounts => ({
        average: _.mean(freightAmounts),
        max: _.max(freightAmounts),
        total: _.sum(freightAmounts),
      }))
      .value();

    return (
      <Backend>
        <div className="content-inner no-padding-top no-padding-left no-padding-right">
          <PageHeader />

          <Box classes="border-bottom side-margins no-vertical-distance">
            <StatsWrapper>
              <Stat
                title="Fat. Médio Hoje"
                subtitle={`Top 1 faturado ${numeral(revenueSummary.max).format('$ 0,0')}`}
                value={numeral(revenueSummary.average).format('$ 0,0')}
                // label="+24%"
                // labelClass="raising"
              />
              <Stat
                title="Veículos"
                subtitle="Ativos hoje na frota"
                value={`${vehiclesCount.total}`}
              />
              <Stat
                title="Estacionados"
                subtitle="deixando de produzir"
                value={`${vehiclesCount.stopped}`}
                label={`${stoppedPercentage}%`}
                labelClass={stoppedPercentage > 30 ? 'descreasing' : 'raising'}
              />
              <Stat
                title="Posicionando"
                subtitle="nas últimas 24 horas"
                value={`${positioningPercentage}%`}
                // label={positioningPercentage > 95 ? 'Bom' : 'Ruim'}
                // labelClass={positioningPercentage > 95 ? 'raising' : 'descreasing'}
              />
            </StatsWrapper>
          </Box>

          <Box title="Overview de Modelos dos Veículos" classes="border-bottom side-margins">
            <ProgressWrapper>
              {modelsCount.map((count, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Progress key={index} size={count[1]} description={count[0]} showStatus />
              ))}
            </ProgressWrapper>
          </Box>

          {/* <Box title="Tempo Produzindo vs. Parado" classes="border-bottom side-margins">
            <Chart />
          </Box> */}

        </div>
      </Backend>
    );
  }
};

DashboardPage.propTypes = {
  vehicles: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      plate: PropTypes.string,
      brand: PropTypes.string,
    }),
  }),
};

DashboardPage.defaultProps = {
  vehicles: {},
};

const mapStateToProps = store => ({
  vehicles: store.vehicleState.vehicles,
});

export default connect(mapStateToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/HomeDashboard/HomeDashboardPage.js